import React, { useEffect, useState, useRef } from "react";
import Loadspinner from "../../../common/Loadspinner";

import CreateKnowledgeService from "../../../services/CreateKnowledgeService";
import { CircularProgressWithLabel } from "./UploadDocument";
import { Modal } from "@material-ui/core";

import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import UploadVid from "./UploadVid";
import { useRecordWebcam } from "react-record-webcam";
//import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg/dist/ffmpeg.min.js";
import RecordRTC from "recordrtc";

//const ffmpeg = createFFmpeg({ log: true });
function VideoRec(props) {
  const toastId = React.useRef(null);
  const [isLoading, setLoading] = useState(false);
  const [video, setVideo] = useState(props.videoBlob);
  const [videoName, setVideoName] = useState(props.fileName);
  const [isVideo, setRecoVid] = useState(false);
  const [isrecorded, setRecorded] = useState(props.videoBlob ? true : false);
  const [videoId, setVideoId] = useState(props.videoId);
  const [firstToken, setToken] = useState("");
  const [, setProgress] = useState(false);
  const [progressStatus, setProgStatus] = useState(0);
  const [thumbnailId, setThumbnailId] = useState(props.thumbnailId);
  const [hideStartStopButton, setHideStartStopButton] = useState(false);

  const [transcriptionData, setTranscriptionData] = useState(
    props.transcription
  );
  const [transcriptionString, setTranscriptionString] = useState(
    props.transcriptionString
  );
  const [editText, setEditText] = useState("");

  const [showNextModals, openNextModals] = useState(false);
  const [showModal, setModal] = useState(true);
  const [stopVideo, setStopVideo] = useState(props.videoBlob ? true : false);

  const [recording, setRecording] = useState(false);
  const [recordVideo, setRecordVideo] = useState(null);
  const [isVideoRecorded, setIsVideoRecorded] = useState(false);

  const mediaStream = useRef(null);
  const recordRTC = useRef(null);
  const webcamRef = useRef(null);

  const [vidLoading, setVidLoading] = useState(false);
  const [vidProgress, setVidProgress] = useState(0);
  const [mp4Blob, setMp4Blob] = useState(null);

  const [progressBar, setProgressBar] = useState(0);
  const [videoInGlobalUrl, setVideoInGlobalUrl] = useState(null);
  const [videoInFilename, setVideoInFilename] = useState(null);
  const [videoInDocumentType, setVideoInDocumentType] = useState(null);
  const [videoInDocValidationResponse, setVideoInDocValidationResponse] = useState(null);

  //const ffmpeg = createFFmpeg({ log: true });
  const recordWebcam = useRecordWebcam({
    mimeType: "application/vnd.apple.mpegurl",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isrecorded) {
      startCam();
      setHideStartStopButton(true);
    }
  }, [isrecorded]);

  const startCam = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        webcamRef.current.srcObject = stream;
      })
      .catch((err) => {
        console.error("Error accessing media devices:", err);
      });
  };

  const startRecording = async () => {
    setStopVideo(false);
    setIsVideoRecorded(false);
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        webcamRef.current.srcObject = stream;
        mediaStream.current = stream; // Store the media stream
        recordRTC.current = RecordRTC(stream, { type: "video", mimeType: "application/vnd.apple.mpegurl" });
        recordRTC.current.startRecording();
        setRecording(true);
      })
      .catch((err) => {
        console.error("Error accessing media devices:", err);
        // Add code to handle errors, such as displaying an error message to the user
      });
  };

  const handleToggleRecording = () => {
    if (recording) {
      stopRecording();
      // setIsUploadVideo(true);
      setRecoVid(true);
    } else {
      startRecording();
    }
  };

  const stopRecording = async () => {
    setStopVideo(true);
    recordRTC.current.stopRecording(() => {
      const recordedBlob = recordRTC.current.getBlob();
      setRecordVideo(recordedBlob);
      setVideo(recordedBlob);

      setRecording(false);
      setIsVideoRecorded(true);
      recordRTC.current.stopRecording();
      // Stop the media stream
      mediaStream.current.getTracks().forEach((track) => track.stop());
    });
  };

  // const [showEditModal, setShowEditModal] = useState();
  const closeModal = () => {
    setModal(false);
    // props.handleModal(false);
  };

  // const closeEditModal = () => {
  //   setShowEditModal("");

  // };

  useEffect(() => {
    getToken();

  }, []);

  const setReco = (vid) => {
    setVideo(vid);
    setRecoVid(true);
  };

  const setRecordedVideo = async () => {
    // let blob = video.slice(0, video.size, "video/webm");
    // let timestamp = Date.now();
    // let newFile = new File([blob], `video${timestamp}.webm`, {
    //   type: "video/webm",
    // });

    // console.log("newFile: ", newFile);

    // setVideo(newFile);
    // setVideoName(newFile.name);

    // // this.setState({ videoRecName: newFile.name });
    // uploadVideoTrans(newFile);

    uploadVideoTrans("newFile");
    // //logEvent(analytics(), "UploadVideoRecording");
  };

  // const convertWebmToMp4 = async (webmBlob) => {
  //   setVidLoading(true);
  //   setVidProgress(0);

  //   const ffmpeg = createFFmpeg({ log: true });
  //   await ffmpeg.load()

  //   ffmpeg.setProgress(({ ratio }) => {
  //     setVidProgress(ratio);
  //   });

  //   ffmpeg.FS("writeFile", "input.webm", await fetchFile(webmBlob));

  //   await ffmpeg.run("-i", "input.webm", "output.mp4");

  //   const mp4Data = ffmpeg.FS("readFile", "output.mp4");
  //   const mp4Blob = new Blob([mp4Data.buffer], { type: "video/mp4" });

  //   setMp4Blob(mp4Blob);

  //   setVidLoading(false);
  // };

  //video transcription
  const uploadVideoTrans = async (FileData) => {
    setLoading(true);
    // const knowledgeData = new FormData();
    // knowledgeData.append("", newFile);
    // const knowledgeData = new FormData();
    // let timestamp = Date.now();
    // let filename = `video${timestamp}.mp4`;
    // knowledgeData.append("video", recordVideo, filename);
    // try {
    //   let byteArray = await fileToByteArray(newFile);
    //   console.log("newFile bytearray: ", byteArray);
    //   console.log("knowledgeData: ", knowledgeData);
    // } catch (err) {
    //   console.error(err);
    // }

    let resp = await CreateKnowledgeService.uploadOnGCPVideoAudio(
      recordVideo,
      (percentage, label = 'Upload') => {
        setProgressBar({ progress: percentage, label: label });
      }
    );

    // let resp = await CreateKnowledgeService.uploadVideo(
    //   firstToken,
    //   knowledgeData,
    //   filename
    // );
    if (resp.data) {
      console.log("resp.data: ", resp.data)
      let { GlobalUrl, FileName, DocumentType, DocValidationResponse } = resp.data;
      setVideoInGlobalUrl(GlobalUrl);
      setVideoInFilename(FileName);
      setVideoInDocumentType(DocumentType);
      setVideoInDocValidationResponse(DocValidationResponse);
      setProgressBar(0);
      setRecoVid(false);
      setRecorded(true);
      // let { id } = resp;
      setVideoId(FileName);
      // getDetails(firstToken, id, filename); // OLD transcript

      // transcript commneted By vishal
      // getDetails1(firstToken, id, filename);
    } else {
      toast(
        "An error occurred while uploading the video file. Please try again later."
      );
    }
    // closeModal();
    // notify();
    setLoading(false);
  };

  // function fileToByteArray(file) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       let reader = new FileReader();
  //       let fileByteArray = [];
  //       reader.readAsArrayBuffer(file);
  //       reader.onloadend = (evt) => {
  //         if (evt.target.readyState == FileReader.DONE) {
  //           let arrayBuffer = evt.target.result,
  //             array = new Uint8Array(arrayBuffer);
  //           for (var byte of array) {
  //             fileByteArray.push(byte);
  //           }
  //         }
  //         resolve(fileByteArray);
  //       };
  //     } catch (e) {
  //       reject(e);
  //     }
  //   });
  // }

  const ProgressBarProcess = ({ progressBar }) => {
    if (progressBar?.progress == 0 || progressBar?.progress == 100) {
      return <p style={{ fontSize: "12px" }}>Processing Please Wait...</p>;
    } else {
      return (
        <>
          <p>{progressBar?.label} Progress: {progressBar?.progress <= 100 && progressBar?.progress}%</p>
          <progress value={progressBar?.progress} max="100"></progress>
        </>
      );
    }
  };

  // const getDetails = async (firstToken, id, fileName) => {
  //   setProgress(true);
  //   let resp = await CreateKnowledgeService.getVideoDetails(firstToken, id);

  //   if (resp.results.length > 0) {
  //     if (resp.result[0].state.toLowerCase() == "failed") {
  //       toast(
  //         "An error occurred while retrieving the audio/video file. Please try again later."
  //       );
  //     } else {
  //       if (
  //         resp.results[0].processingProgress != "" &&
  //         resp.results[0].processingProgress != "100%"
  //       ) {
  //         setTimeout(() => (resp = getDetails(firstToken, id, fileName)), 3000);
  //         let status = parseInt(resp.results[0].processingProgress);
  //         setProgStatus(status);

  //         dispatch(progressVideo(status));
  //       } else if (resp.results[0].processingProgress == "") {
  //         setProgress(false);
  //         toast(
  //           "An error occurred while retrieving the audio/video file. Please try again later."
  //         );
  //       } else {
  //         dispatch(progressVideo(100));
  //         setThumbnailId(resp.results[0].thumbnailId);
  //         getVideoToken(id);
  //         let response = await CreateKnowledgeService.getVideoToken(id);
  //         if (response) {
  //           let res = await CreateKnowledgeService.getTranscription(
  //             id,
  //             response
  //           );
  //           if (res) {
  //             let data = {
  //               transcript: res.videos[0].insights.transcript,
  //             };
  //             let transcript = JSON.stringify(data);
  //             setTranscriptionString(transcript);
  //             let rets = transcript.replace("/", "");
  //             let json_trans = JSON.parse(rets);
  //             setTranscriptionData(json_trans.transcript);
  //             update();

  //             dispatch(
  //               uploadVideo(
  //                 fileName,
  //                 id,
  //                 resp.results[0].thumbnailId,
  //                 json_trans.transcript,
  //                 "video",
  //                 window.URL.createObjectURL(recordVideo)
  //               )
  //             );
  //           }
  //         }
  //       }
  //     }
  //   }
  // };
  // transcripting
  // const getDetails1 = async (firstToken, id, fileName) => {
  //   setProgress(true);
  //   let resp = await CreateKnowledgeService.getVideoDetails1(
  //     firstToken,
  //     fileName,
  //     id
  //   );

  //   if (resp?.hasOwnProperty("results") && resp.results.length > 0) {
  //     let findVideoArray = resp.results.find((vid) => {
  //       return vid.id == id;
  //     });
  //     if (findVideoArray) {
  //       if (findVideoArray.state.toLowerCase() == "failed") {
  //         toast(
  //           "An error occurred while retrieving the audio/video file. Please try again later."
  //         );
  //       } else {
  //         if (
  //           findVideoArray.processingProgress != "100%" &&
  //           findVideoArray.processingProgress != ""
  //         ) {
  //           setTimeout(
  //             () => (resp = getDetails1(firstToken, id, fileName)),
  //             3000
  //           );
  //           let status = parseInt(findVideoArray.processingProgress);
  //           setProgStatus(status);

  //           dispatch(progressVideo(status));
  //         } else if (findVideoArray.processingProgress == "") {
  //           setProgress(false);
  //           toast(
  //             "An error occurred while retrieving the audio/video file. Please try again later."
  //           );
  //         } else {
  //           dispatch(progressVideo(100));
  //           setThumbnailId(findVideoArray.thumbnailId);
  //           getVideoToken(id);
  //           let response = await CreateKnowledgeService.getVideoToken(id);
  //           if (response) {
  //             let res = await CreateKnowledgeService.getTranscription(
  //               id,
  //               response
  //             );
  //             if (res) {
  //               let data = {
  //                 transcript: res.videos[0].insights.transcript,
  //               };
  //               let transcript = JSON.stringify(data);
  //               setTranscriptionString(transcript);
  //               let rets = transcript.replace("/", "");
  //               let json_trans = JSON.parse(rets);
  //               setTranscriptionData(json_trans.transcript);
  //               update();

  //               dispatch(
  //                 uploadVideo(
  //                   fileName,
  //                   id,
  //                   findVideoArray.thumbnailId,
  //                   json_trans.transcript,
  //                   "video",
  //                   window.URL.createObjectURL(video)
  //                 )
  //               );
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // };

  const notify = () =>
  (toastId.current = toast.info(
    "Uploading video, check progress in Notification tab!",
    { autoClose: false, theme: "dark" }
  ));

  // const update = () =>
  //   toast.update(toastId.current, {
  //     render: "upload done",
  //     type: toast.TYPE.INFO,
  //     autoClose: 5000,
  //   });

  // const getVideoToken = async (id) => {
  //   let res = await CreateKnowledgeService.getVideoToken(id);
  //   if (res) {
  //     getTranscriptionData(id, res);
  //   }
  // };

  // const getTranscriptionData = async (id, tok) => {
  //   let res = await CreateKnowledgeService.getTranscription(id, tok);
  //   if (res) {
  //     let data = {
  //       transcript: res.videos[0].insights.transcript,
  //     };
  //     let transcript = JSON.stringify(data);
  //     setTranscriptionString(transcript);
  //     let rets = transcript.replace("/", "");
  //     let json_trans = JSON.parse(rets);
  //     setTranscriptionData(json_trans.transcript);
  //   }
  //   setRecorded(true);
  //   setProgress(false);
  // };

  //token

  const getToken = async () => {
    const res = await CreateKnowledgeService.firstApi();
    if (res) {
      setToken(res);
    }
  };

  //edit transcription

  const showEditModal = (actualText) => {
    setEditText(actualText);
  };
  const closeEditModal = () => {
    setEditText("");
  };

  const setEditedText = (e) => {
    setEditText(e.target.value);
  };

  const editTranscription = (editId) => {
    let transArray = transcriptionData;
    transArray.map((item) => {
      item.id == editId ? (item.text = editText) : null;
    });
    setTranscriptionData(transArray);
    closeEditModal();
  };

  const saveFile = async () => {
    const blob = await recordWebcam.getRecording();
    console.log(`blob?.length: ${blob?.length}`);

    setReco(blob);
    setStopVideo(true);
  };

  return (
    <div>
      <Loadspinner
        filename="VideoRec.js"
        isLoading={isLoading}
        isMiddle="true"
      />
      {/* <div
        data-bs-toggle="modal"
        data-bs-target="#record-video"
        style={{ cursor: "pointer", fontSize: "10px" }}
        onClick={getToken}
      >
        <img src={images.video_rec} className="header-navimg-av" />
        <span className="header-text">Record Video</span>
      </div>

      <div
        className="modal fade"
        id="record-video"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      > */}
      <Modal
        open={showModal && !showNextModals}
        onClose={closeModal}
        className={
          isrecorded &&
            transcriptionString != null &&
            transcriptionString != "{}" &&
            transcriptionString != ""
            ? "modal-dialog modal-dialog-centered modal-xl"
            : "modal-dialog modal-dialog-centered modal-lg"
        }
      >
        <div className="modal-content">
          <Modal
            disablePortal
            disableEnforceFocus
            disableAutoFocus
            open={false}
            style={{ background: "transparent" }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
              }}
            >
              <CircularProgressWithLabel
                value={Number.isNaN(progressStatus) ? 0 : progressStatus}
                style={{ width: "100px" }}
              />
              <p style={{ margin: "25px", color: "white" }}>Uploading Video</p>
            </div>
          </Modal>
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
              Record and Upload video
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <div className="display-row justify-space-around">
              <div style={{ width: "44vw", height: "60vh" }}>
                {/* <p>Camera status: {recordWebcam.status}</p>
                <button onClick={recordWebcam.open}>Open camera</button>
                <button onClick={recordWebcam.start}>Start recording</button>
                <button onClick={recordWebcam.stop}>Stop recording</button>
                <button onClick={recordWebcam.retake}>Retake recording</button>
                <button onClick={recordWebcam.download}>Download recording</button>
                <button onClick={saveFile}>Save file to server</button>
                <video
                  ref={recordWebcam.status == 'PREVIEW' ? recordWebcam.previewRef : recordWebcam.webcamRef}
                  autoPlay
                  muted
                  loop
                  style={{
                    height: "20rem"
                  }}
                /> */}

                {!stopVideo ? (
                  <div className="row">
                    <video
                      ref={webcamRef}
                      autoPlay
                      muted
                      style={{ width: "100%", height: "300px" }}
                    ></video>
                    {/* <RecordWebcam
                      className="col"
                      options={{
                        mimeType: "video/mp4",
                        recordingLength: 300000
                      }} /> */}
                    {/* <VideoRecorder
                      className="col"
                      showReplayControls
                      timeLimit={300000}
                      isOnInitially
                      onRecordingComplete={async (videoBlob) => {
                        // await ffmpeg.load();
                        // ffmpeg.FS('writeFile', "testFile1", await fetchFile(videoBlob));
                        // await ffmpeg.run('-i', "testFile1", 'output.mp4');
                        // const data = ffmpeg.FS('readFile', 'output.mp4');

                        // const newData = new Blob([data.buffer], { type: 'video/mp4' });
                        // setReco(newData);
                        // setStopVideo(true);

                        // console.log("videoBlob", newData);
                        // const webmBlob = new Blob({ type: 'video/webm' });
                        // const webmBlob = new Blob(videoBlob);
                        // await convertWebmToMp4(videoBlob);

                        //Old changes
                        console.log("videoBlob: ", videoBlob);
                        setReco(videoBlob);
                        setStopVideo(true);
                      }}
                    /> */}
                  </div>
                ) : (
                  <>
                    {isVideoRecorded && (
                      <>
                        <video
                          style={{ width: "100%", height: "300px" }}
                          src={URL.createObjectURL(recordVideo)}
                          controls
                        ></video>
                        <p style={{ display: "none" }}>Recorded</p>
                      </>
                    )}
                    {typeof video !== "object" && (
                      <video
                        width="510"
                        height="380"
                        src={video}
                        autoPlay
                        controls
                      />
                    )}
                  </>
                )}
                {hideStartStopButton && (
                  <div className="row">
                    <button onClick={handleToggleRecording}>
                      {recording ? "Stop Recording" : "Start Recording"}
                    </button>
                  </div>
                )}

                {/* {!isrecorded && (
                  <>
                    <video
                      style={{ width: "100%", height: "300px" }}
                      src={URL.createObjectURL(video)}
                      controls
                    ></video>
                    <p style={{ display: "none" }}>Recorded</p>
                  </>
                )} */}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        setRecordedVideo();
                      }}
                      disabled={!isVideo}
                    >
                      Upload
                    </button>
                  </div>

                  <div>
                    {progressBar?.progress > 0 && (
                      <div>
                        <ProgressBarProcess progressBar={progressBar} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* {isrecorded &&
              transcriptionString != null &&
              transcriptionString != "{}" &&
              transcriptionString != "" ? (
                transcriptionData.length > 0 ? (
                  <div
                    className="display-col  card "
                    style={{ maxHeight: "70vh", overflowY: "scroll" }}
                  >
                    <h6>Transcription</h6>
                    {transcriptionData.map((transc) => {
                      let target = `#modal${transc.id}`;
                      let modalId = `modal${transc.id}`;
                      return (
                        <div key={transc.id} className="card-body display-row ">
                          <p>{transc.instances[0].start}</p>
                          <span style={{ marginLeft: "7px" }}>
                            {transc.text}
                          </span>
                          <img
                            src={images.edit}
                            className="edit-img"
                            data-bs-toggle="modal"
                            data-bs-target={target}
                            onClick={() => showEditModal(transc.text)}
                          />
                          <div
                            className="modal fade"
                            id={modalId}
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            tabIndex="-1"
                            aria-labelledby="staticBackdropLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content edit-modal">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="staticBackdropLabel"
                                  >
                                    Edit
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={closeEditModal}
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <input
                                    type="text"
                                    value={editText}
                                    className="edit-input form-control"
                                    onChange={setEditedText}
                                    autoComplete={
                                      CommonConstants.autoCompleteInput
                                    }
                                  />
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={closeEditModal}
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => editTranscription(transc.id)}
                                    data-bs-dismiss="modal"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null
              ) : null} */}
            </div>
          </div>
          <div className="modal-footer" style={{ margin: "6vh 0 1vh 0" }}>
            <button
              type="button"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              style={{ marginRight: "20px" }}
              onClick={closeModal}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => {
                openNextModals(true);
              }}
              disabled={!isrecorded}
              style={{ marginRight: "20px" }}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>

      {/* <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={handleClose} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* </div> */}
      {showNextModals && (
        <UploadVid
          isAudio={false}
          fileName={videoName}
          videoId={videoId}
          videoInGlobalUrl={videoInGlobalUrl}
          videoInFilename={videoInFilename}
          videoInDocumentType={videoInDocumentType}
          videoInDocValidationResponse={videoInDocValidationResponse}
          thumbnailId={thumbnailId}
          transcription={transcriptionString}
          handleModal={openNextModals}
          handlePrevious={setModal}
          type="application/vnd.apple.mpegurl"
        />
      )}
    </div>
  );
}

export default VideoRec;

VideoRec.propTypes = {
  handleModal: PropTypes.func,
  videoBlob: PropTypes.object,
  transcription: PropTypes.array,
  fileName: PropTypes.string,
  thumbnailId: PropTypes.string,
  videoId: PropTypes.string,
  transcriptionString: PropTypes.string,
};

VideoRec.defaultProps = {
  videoBlob: null,
  transcription: [],
};
